import * as React from "react";
// import styles from "../../../LeftNavigation/DesignerControls/BasicControls.module.css"

function LinkIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17"><defs> </defs>
    <g transform="translate(-1.495 -1.505)">
    <path fill="none" stroke={props?.style?.stroke || "#606060"} strokeLinecap="round" strokeLinejoin="round" d="M10,10.038a3.653,3.653,0,0,0,5.509.395L17.7,8.241a3.653,3.653,0,1,0-5.166-5.166l-1.256,1.25" transform="translate(-0.776 0)"/>
    <path fill="none" stroke={props?.style?.stroke || "#606060"} strokeLinecap="round" strokeLinejoin="round" d="M10.766,10.46a3.653,3.653,0,0,0-5.509-.395L3.065,12.257a3.653,3.653,0,1,0,5.166,5.166l1.249-1.25" transform="translate(0 -0.488)"/>
    </g></svg>

  );
}

export default LinkIcon;